var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "q-modal",
        {
          attrs: {
            "content-css": {
              minWidth: _vm.getMinWidth,
              maxWidth: _vm.getMaxWidth,
              minHeight: "80vh"
            },
            "no-backdrop-dismiss": "",
            "no-esc-dismiss": ""
          },
          on: {
            hide: function($event) {
              return _vm.hideTaskModal()
            }
          },
          model: {
            value: _vm.show_task,
            callback: function($$v) {
              _vm.show_task = $$v
            },
            expression: "show_task"
          }
        },
        [
          _c(
            "q-modal-layout",
            [
              _c(
                "q-toolbar",
                { attrs: { slot: "header" }, slot: "header" },
                [
                  _c("q-btn", {
                    attrs: {
                      flat: "",
                      round: "",
                      dense: "",
                      icon: "fas fa-times"
                    },
                    on: {
                      click: function($event) {
                        return _vm.hideTaskModal()
                      }
                    }
                  }),
                  _c("q-toolbar-title", [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.$t("task")) +
                        "\n                "
                    )
                  ])
                ],
                1
              ),
              _c("div", { staticClass: "layout-padding" }, [
                _c("div", { staticClass: "row gutter-sm" }, [
                  _c(
                    "div",
                    { staticClass: "col-12" },
                    [
                      _c(
                        "q-input",
                        {
                          attrs: {
                            "float-label": _vm.$t("branch"),
                            autocomplete: "new-password",
                            error: _vm.$v.task_data.branch_name.$error,
                            clearable: "",
                            disabled: _vm.disableStep
                          },
                          on: {
                            input: _vm.$v.task_data.branch_name.$touch,
                            clear: _vm.clearBranch
                          },
                          model: {
                            value: _vm.task_data.branch_name,
                            callback: function($$v) {
                              _vm.$set(_vm.task_data, "branch_name", $$v)
                            },
                            expression: "task_data.branch_name"
                          }
                        },
                        [
                          _c("q-autocomplete", {
                            attrs: {
                              "min-characters": 3,
                              "value-field": function(v) {
                                return "" + v.name
                              },
                              separator: ""
                            },
                            on: {
                              search: _vm.getBranch,
                              selected: _vm.selectBranch
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "col-12" },
                    [
                      _c("q-input", {
                        attrs: {
                          "float-label": _vm.$t("address"),
                          error: _vm.$v.task_data.branch_address.$error,
                          disable: ""
                        },
                        on: { input: _vm.$v.task_data.branch_address.$touch },
                        model: {
                          value: _vm.task_data.branch_address,
                          callback: function($$v) {
                            _vm.$set(_vm.task_data, "branch_address", $$v)
                          },
                          expression: "task_data.branch_address"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "col-xs-12 col-sm-6" },
                    [
                      _c("q-input", {
                        attrs: {
                          "float-label": _vm.$t("latitude"),
                          error: _vm.$v.task_data.branch_lat.$error,
                          disable: ""
                        },
                        on: { input: _vm.$v.task_data.branch_lat.$touch },
                        model: {
                          value: _vm.task_data.branch_lat,
                          callback: function($$v) {
                            _vm.$set(_vm.task_data, "branch_lat", $$v)
                          },
                          expression: "task_data.branch_lat"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "col-xs-12 col-sm-6" },
                    [
                      _c("q-input", {
                        attrs: {
                          "float-label": _vm.$t("longitude"),
                          error: _vm.$v.task_data.branch_long.$error,
                          disable: ""
                        },
                        on: { input: _vm.$v.task_data.branch_long.$touch },
                        model: {
                          value: _vm.task_data.branch_long,
                          callback: function($$v) {
                            _vm.$set(_vm.task_data, "branch_long", $$v)
                          },
                          expression: "task_data.branch_long"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "col-xs-12 col-sm-12" },
                    [
                      _c("q-select", {
                        attrs: {
                          options: _vm.collections,
                          "float-label": _vm.$t("questionary"),
                          error: _vm.$v.task_data.collection.$error,
                          disable: _vm.disableStep
                        },
                        on: { input: _vm.$v.task_data.collection.$touch },
                        model: {
                          value: _vm.task_data.collection,
                          callback: function($$v) {
                            _vm.$set(_vm.task_data, "collection", $$v)
                          },
                          expression: "task_data.collection"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "col-xs-12 col-sm-6" },
                    [
                      _c("q-datetime", {
                        attrs: {
                          type: "time",
                          "float-label": _vm.$t("start_time"),
                          format: "HH:mm:ss",
                          disabled: _vm.disableStep
                        },
                        model: {
                          value: _vm.start_time,
                          callback: function($$v) {
                            _vm.start_time = $$v
                          },
                          expression: "start_time"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "col-xs-12 col-sm-6" },
                    [
                      _c("q-datetime", {
                        attrs: {
                          type: "time",
                          "float-label": _vm.$t("end_time"),
                          format: "HH:mm:ss",
                          disabled: _vm.disableStep
                        },
                        model: {
                          value: _vm.end_time,
                          callback: function($$v) {
                            _vm.end_time = $$v
                          },
                          expression: "end_time"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "col-12" },
                    [
                      _c("q-input", {
                        attrs: {
                          type: "textarea",
                          "float-label": _vm.$t("observation"),
                          disabled: _vm.disableStep
                        },
                        model: {
                          value: _vm.observation_request,
                          callback: function($$v) {
                            _vm.observation_request = $$v
                          },
                          expression: "observation_request"
                        }
                      })
                    ],
                    1
                  )
                ]),
                _c(
                  "div",
                  { staticClass: "row gutter-sm justify-end q-mt-sm" },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "col-xs-12 col-sm-3",
                        class: _vm.getOrder("cancel")
                      },
                      [
                        _c("q-btn", {
                          staticClass: "full-width",
                          attrs: {
                            color: "tertiary",
                            label: _vm.$t("cancel"),
                            icon: "fas fa-ban"
                          },
                          on: {
                            click: function($event) {
                              return _vm.hideTaskModal()
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticClass: "col-xs-12 col-sm-3",
                        class: _vm.getOrder("save")
                      },
                      [
                        _c("q-btn", {
                          staticClass: "full-width",
                          attrs: {
                            color: "secondary",
                            label: _vm.$t("save"),
                            icon: "far fa-save",
                            disabled: _vm.disableStep
                          },
                          on: {
                            click: function($event) {
                              return _vm.saveTask()
                            }
                          }
                        })
                      ],
                      1
                    )
                  ]
                )
              ])
            ],
            1
          )
        ],
        1
      ),
      _c(
        "q-modal",
        {
          attrs: {
            "no-backdrop-dismiss": "",
            "no-esc-dismiss": "",
            "content-css": {
              minWidth: _vm.getMinWidth,
              maxWidth: _vm.getMaxWidth,
              minHeight: "80vh"
            }
          },
          model: {
            value: _vm.show_address,
            callback: function($$v) {
              _vm.show_address = $$v
            },
            expression: "show_address"
          }
        },
        [
          _c(
            "q-modal-layout",
            [
              _c(
                "q-toolbar",
                { attrs: { slot: "header" }, slot: "header" },
                [
                  _c("q-btn", {
                    attrs: {
                      flat: "",
                      round: "",
                      dense: "",
                      icon: "fas fa-times"
                    },
                    on: {
                      click: function($event) {
                        _vm.show_address = false
                      }
                    }
                  }),
                  _c("q-toolbar-title", [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.$t("confirm_address")) +
                        "\n                "
                    )
                  ])
                ],
                1
              ),
              _c("div", { staticClass: "layout-padding" }, [
                _c("div", { staticClass: "row gutter-sm" }, [
                  _c(
                    "div",
                    { staticClass: "col-xs-12 col-sm-12" },
                    [
                      _c(
                        "q-alert",
                        { attrs: { color: "info", icon: "fas fa-info" } },
                        [
                          _vm._v(
                            "\n                            " +
                              _vm._s(
                                _vm.$t(
                                  "use_the_address_field_to_search_for_the_correct_address_if_the_complete_address_button_doesnt_work_properly"
                                )
                              ) +
                              "\n                        "
                          )
                        ]
                      )
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "col-xs-12 col-sm-12" },
                    [
                      _c(
                        "q-input",
                        {
                          attrs: {
                            "float-label": _vm.$t("address"),
                            autocomplete: "new-password",
                            error: _vm.$v.address.address.$error
                          },
                          on: { input: _vm.$v.address.address.$touch },
                          model: {
                            value: _vm.address.address,
                            callback: function($$v) {
                              _vm.$set(_vm.address, "address", $$v)
                            },
                            expression: "address.address"
                          }
                        },
                        [
                          _c("q-autocomplete", {
                            attrs: { "min-characters": 3, separator: "" },
                            on: {
                              search: _vm.getAddress,
                              selected: _vm.selectedAddress
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "col-xs-12 col-sm-6" },
                    [
                      _c("q-input", {
                        attrs: {
                          error: _vm.$v.address.lat.$error,
                          "float-label": _vm.$t("latitude")
                        },
                        on: { input: _vm.$v.address.lat.$touch },
                        model: {
                          value: _vm.address.lat,
                          callback: function($$v) {
                            _vm.$set(_vm.address, "lat", $$v)
                          },
                          expression: "address.lat"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "col-xs-12 col-sm-6" },
                    [
                      _c("q-input", {
                        attrs: {
                          error: _vm.$v.address.long.$error,
                          "float-label": _vm.$t("longitude")
                        },
                        on: { input: _vm.$v.address.long.$touch },
                        model: {
                          value: _vm.address.long,
                          callback: function($$v) {
                            _vm.$set(_vm.address, "long", $$v)
                          },
                          expression: "address.long"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "col-xs-12 col-sm-4" },
                    [
                      _c("q-input", {
                        ref: "number",
                        attrs: { "float-label": _vm.$t("number") },
                        model: {
                          value: _vm.address.number,
                          callback: function($$v) {
                            _vm.$set(_vm.address, "number", $$v)
                          },
                          expression: "address.number"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "col-xs-12 col-sm-4" },
                    [
                      _c("q-input", {
                        attrs: { "float-label": _vm.$t("complement") },
                        model: {
                          value: _vm.address.complement,
                          callback: function($$v) {
                            _vm.$set(_vm.address, "complement", $$v)
                          },
                          expression: "address.complement"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "col-xs-12 col-sm-4" },
                    [
                      _c("q-input", {
                        attrs: { "float-label": _vm.$t("neighborhood") },
                        model: {
                          value: _vm.address.neighborhood,
                          callback: function($$v) {
                            _vm.$set(_vm.address, "neighborhood", $$v)
                          },
                          expression: "address.neighborhood"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "col-xs-12 col-sm-4" },
                    [
                      _c("q-input", {
                        attrs: { "float-label": _vm.$t("postal_code") },
                        model: {
                          value: _vm.address.postal_code,
                          callback: function($$v) {
                            _vm.$set(_vm.address, "postal_code", $$v)
                          },
                          expression: "address.postal_code"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "col-xs-12 col-sm-4" },
                    [
                      _c("q-input", {
                        attrs: {
                          "float-label": _vm.$t("city"),
                          error: _vm.$v.address.city.$error
                        },
                        on: { input: _vm.$v.address.city.$touch },
                        model: {
                          value: _vm.address.city,
                          callback: function($$v) {
                            _vm.$set(_vm.address, "city", $$v)
                          },
                          expression: "address.city"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "col-xs-12 col-sm-4" },
                    [
                      _c("q-input", {
                        attrs: {
                          "float-label": _vm.$t("state"),
                          error: _vm.$v.address.state.$error
                        },
                        on: { input: _vm.$v.address.state.$touch },
                        model: {
                          value: _vm.address.state,
                          callback: function($$v) {
                            _vm.$set(_vm.address, "state", $$v)
                          },
                          expression: "address.state"
                        }
                      })
                    ],
                    1
                  )
                ]),
                _c(
                  "div",
                  { staticClass: "row gutter-sm justify-end q-mt-sm" },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "col-xs-12 col-sm-3",
                        class: _vm.getOrder("cancel")
                      },
                      [
                        _c("q-btn", {
                          staticClass: "full-width",
                          attrs: {
                            color: "tertiary",
                            label: _vm.$t("cancel"),
                            icon: "fas fa-chevron-left"
                          },
                          on: {
                            click: function($event) {
                              _vm.show_address = false
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-xs-12 col-sm-3" },
                      [
                        _c("q-btn", {
                          staticClass: "full-width",
                          attrs: {
                            color: "positive",
                            label: _vm.$t("complete_address"),
                            icon: "fas fa-check"
                          },
                          on: {
                            click: function($event) {
                              return _vm.completeAddress()
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticClass: "col-xs-12 col-sm-3",
                        class: _vm.getOrder("save")
                      },
                      [
                        _c("q-btn", {
                          staticClass: "full-width",
                          attrs: {
                            color: "secondary",
                            label: _vm.$t("save"),
                            icon: "far fa-save"
                          },
                          on: {
                            click: function($event) {
                              return _vm.saveAddress()
                            }
                          }
                        })
                      ],
                      1
                    )
                  ]
                )
              ])
            ],
            1
          )
        ],
        1
      ),
      _c(
        "q-modal",
        {
          attrs: {
            "no-backdrop-dismiss": "",
            "no-esc-dismiss": "",
            "content-css": {
              minWidth: _vm.getMinWidth,
              maxWidth: _vm.getMaxWidth,
              minHeight: "80vh"
            }
          },
          model: {
            value: _vm.show_address_list,
            callback: function($$v) {
              _vm.show_address_list = $$v
            },
            expression: "show_address_list"
          }
        },
        [
          _c(
            "q-modal-layout",
            [
              _c(
                "q-toolbar",
                { attrs: { slot: "header" }, slot: "header" },
                [
                  _c("q-btn", {
                    attrs: {
                      flat: "",
                      round: "",
                      dense: "",
                      icon: "fas fa-times"
                    },
                    on: {
                      click: function($event) {
                        _vm.show_address = false
                      }
                    }
                  }),
                  _c("q-toolbar-title", [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.$t("address_list")) +
                        "\n                "
                    )
                  ])
                ],
                1
              ),
              _c("div", { staticClass: "layout-padding" }, [
                _c("div", { staticClass: "row gutter-sm" }, [
                  _c(
                    "div",
                    { staticClass: "col-12" },
                    [
                      _c(
                        "q-alert",
                        { attrs: { color: "info", icon: "fas fa-info" } },
                        [
                          _vm._v(
                            "\n                            " +
                              _vm._s(
                                _vm.$t("select_one_address_from_the_list")
                              ) +
                              "\n                        "
                          )
                        ]
                      )
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "col-12" },
                    [
                      _c("q-option-group", {
                        attrs: {
                          color: "secondary",
                          type: "radio",
                          options: _vm.address_list,
                          "no-parent-field": ""
                        },
                        model: {
                          value: _vm.selected_address,
                          callback: function($$v) {
                            _vm.selected_address = $$v
                          },
                          expression: "selected_address"
                        }
                      })
                    ],
                    1
                  )
                ]),
                _c(
                  "div",
                  { staticClass: "row gutter-sm justify-end q-mt-sm" },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "col-xs-12 col-sm-3",
                        class: _vm.getOrder("cancel")
                      },
                      [
                        _c("q-btn", {
                          staticClass: "full-width",
                          attrs: {
                            color: "tertiary",
                            label: _vm.$t("cancel"),
                            icon: "fas fa-chevron-left"
                          },
                          on: {
                            click: function($event) {
                              _vm.show_address_list = false
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticClass: "col-xs-12 col-sm-3",
                        class: _vm.getOrder("save")
                      },
                      [
                        _c("q-btn", {
                          staticClass: "full-width",
                          attrs: {
                            color: "secondary",
                            label: _vm.$t("select"),
                            icon: "fas fa-check"
                          },
                          on: {
                            click: function($event) {
                              return _vm.selectAddress()
                            }
                          }
                        })
                      ],
                      1
                    )
                  ]
                )
              ])
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }